import { Link } from "@inertiajs/react";
import { Box, Container, Heading, Table, Text, Link as CLink } from "@chakra-ui/react";
import { Game, Player } from "@/types";
import { formatDate, formatTime } from "@/lib/utils";
import { player_path } from "@/routes";
import Head from "@/components/Head";

interface Props {
  player: Player;
  latest_rating_score: number;
  games: Game[];
  notice?: string;
}

export default function Show({ player, latest_rating_score, games }: Props) {
  return (
    <>
      <Head title={`${player.display_name}のプロフィール`} robots={true} />

      <Container maxW="4xl" p={6}>
        <div className="flex flex-col gap-6">
          <Box>
            <Heading as="h1" size="lg">{player.display_name}</Heading>
            <Text fontSize="md" color="gray.600">
              ID: {player.player_id}
            </Text>
          </Box>

          <Text fontSize="lg">レーティング: {latest_rating_score}</Text>

          <Box bg="white" rounded="md" shadow="md" w="full" overflow="auto">
            <Table.Root variant="line">
              <Table.Header bg="gray.100">
                <Table.Row>
                  <Table.ColumnHeader color="gray.700">対戦相手</Table.ColumnHeader>
                  <Table.ColumnHeader color="gray.700">結果</Table.ColumnHeader>
                  <Table.ColumnHeader color="gray.700">日時</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {games.map((game, i) => (
                  <Table.Row key={i} _hover={{ bg: "gray.50" }}>
                    <Table.Cell>
                      <CLink asChild>
                        <Link href={player_path(game.player2.player_id)} className="block">
                          <Text fontWeight="medium">{game.player2.display_name || game.player2.player_id}</Text>
                          <Text fontSize="xs">ID: {game.player2.player_id}</Text>
                          <Text fontSize="xs">RT: {game.player2_rating_score ?? "N/A"}</Text>
                        </Link>
                      </CLink>
                    </Table.Cell>
                    <Table.Cell>
                      {game.player1_point > game.player2_point ? <span className="text-red-700 pr-2">W</span> : <span className="text-blue-700 pr-2">L</span>}
                      {game.player1_point ?? "N/A"} - {game.player2_point ?? "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {formatDate(game.created_at)}
                      <br />
                      {formatTime(game.created_at)}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Root>
          </Box>
        </div>
      </Container>
    </>
  );
}
